import { DownloadFilesDiagnosisReport } from '~/domain/usecases/diagnosisReport/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteDownloadFilesDiagnosisReport
  implements DownloadFilesDiagnosisReport
{
  private readonly url: string;

  private readonly httpClient: HttpClient<DownloadFilesDiagnosisReport.Model>;

  constructor(
    url: string,
    httClient: HttpClient<DownloadFilesDiagnosisReport.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  download = async (
    params: DownloadFilesDiagnosisReport.Params,
  ): Promise<DownloadFilesDiagnosisReport.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params?.report}/DOWNLOAD`,
      method: 'get',
      responseType: 'blob',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      default:
        throw new UnexpectedError();
    }
  };
}
